import * as React from 'react';
import * as _ from 'underscore';

import { Messages } from '../../codegen/Localize';
import { Telemetry } from '../../ts/services/TelemetryService';
import { ServerUrls } from '../ServerUrls';
import { LayoutType } from '../state/LayoutType';
import { ConnectedNavPanel } from './ConnectedNavPanel';
import { NavStyles } from './NavigationStyles';
import { NavPanelButton } from './NavPanelButton';

export type LeftNavVisibility = 'expanded' | 'minimized';

export interface LeftNavState {
  readonly visibility: LeftNavVisibility;
  readonly userSetVisibility: boolean;
  readonly userVisiblityChoice: LeftNavVisibility;
}

export interface LeftNavStateProps {
  readonly isInVizViewerArea: boolean;
  readonly layoutType: LayoutType;
}

export interface LeftNavOwnProps {
  readonly telemetryService: Telemetry;
}

export type LeftNavProps = LeftNavOwnProps & LeftNavStateProps;

export class LeftNav extends React.PureComponent<LeftNavProps, LeftNavState> {
  public constructor(props: LeftNavProps) {
    super(props);
    // this will get overridden by getDerivedStateFromProps before first render
    // But I need to add so tests play nice because shallow render doesn't call getDerivedStateFromProps
    this.state = {
      visibility: LeftNav.getVisibilityFromLayoutType(props.layoutType),
      userSetVisibility: false,
      userVisiblityChoice: 'expanded'
    };
  }

  // Takes the user choice if the user has set it.
  static getDerivedStateFromProps(nextProps: LeftNavProps, prevState: LeftNavState): Partial<LeftNavState>{
    const visibility = prevState.userSetVisibility ? prevState.userVisiblityChoice : LeftNav.getVisibilityFromLayoutType(nextProps.layoutType);
    return {
      visibility
    };
  }

  public render(): JSX.Element {
    if (this.props.isInVizViewerArea) {
      return null;
    }

    return (
      <div className={NavStyles.getLeftNavClassNames(this.state.visibility)}>
        <NavPanelButton
          panelState={this.state.visibility}
          toggleNavPanel={this.toggleLeftNav}
          panelOpenMessage={Messages.leftNavToggleButtonCollapse()}
          telemetryService={this.props.telemetryService}
        />
        <ConnectedNavPanel
          navPanelDisplayMode={this.state.visibility === 'expanded' ? 'iconAndText' : 'icon'}
          serverUrls={ServerUrls.getInstance()}
          onSitePickerClick={this.openPanel}
          telemetryService={this.props.telemetryService}
        />
      </div>
    );
  }

  static getVisibilityFromLayoutType(layoutType: LayoutType): LeftNavVisibility {
    return layoutType === 'desktop' ? 'expanded' : 'minimized';
  }

  private toggleLeftNav = () => {
    this.setState((oldState) => {
      const toggledVisibility = (oldState.visibility === 'expanded' ? 'minimized' : 'expanded');
      return { userSetVisibility: true, userVisiblityChoice: toggledVisibility };
    });
  }

  private openPanel = () => {
    this.setState({userVisiblityChoice: 'expanded', userSetVisibility: true});
  }
}
